/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Category_PlaceholderInputs */

const en_directory_vibebids_category_placeholder = /** @type {(inputs: Directory_Vibebids_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a category`)
};

const zh_directory_vibebids_category_placeholder = /** @type {(inputs: Directory_Vibebids_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择分类`)
};

/**
* | output |
* | --- |
* | "Choose a category" |
*
* @param {Directory_Vibebids_Category_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_category_placeholder = /** @type {((inputs?: Directory_Vibebids_Category_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Category_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_category_placeholder(inputs)
	return zh_directory_vibebids_category_placeholder(inputs)
});
export { directory_vibebids_category_placeholder as "directory.vibebids.category_placeholder" }